import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        py: 4,
        mt: 'auto',
        alignContent: 'center'
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{ 
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
            gap: 4,
            justifyItems: 'center',
            textAlign: 'center'
          }}
        >
          {/* Coordonnées */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Stack spacing={2} alignItems="center">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon />
                <Link 
                  href="tel:+33000000000" 
                  color="inherit"
                  sx={{ '&:hover': { color: 'primary.dark' } }}
                >
                  +33 0 00 00 00 00
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon />
                <Link 
                  href="mailto:contact@up-stage.fr" 
                  color="inherit"
                  sx={{ '&:hover': { color: 'primary.dark' } }}
                >
                  contact@up-stage.fr
                </Link>
              </Box>
            </Stack>
          </Box>

          {/* Liens utiles */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Liens utiles
            </Typography>
            <Stack spacing={2} alignItems="center">
              <Link 
                component={RouterLink} 
                to="/mentions-legales" 
                color="inherit"
                sx={{ '&:hover': { color: 'primary.dark' } }}
              >
                Mentions légales
              </Link>
              <Link 
                component={RouterLink} 
                to="/plan-du-site" 
                color="inherit"
                sx={{ '&:hover': { color: 'primary.dark' } }}
              >
                Plan du site
              </Link>
            </Stack>
          </Box>

          {/* Réseaux sociaux */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Suivez-nous
            </Typography>
            <Stack 
              direction="row" 
              spacing={2} 
              justifyContent="center"
            >
              <Link 
                href="https://www.instagram.com/up_stage_officiel"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                sx={{ 
                  '&:hover': { 
                    color: 'primary.dark',
                    transform: 'scale(1.1)'
                  },
                  transition: 'transform 0.2s'
                }}
              >
                <InstagramIcon sx={{ fontSize: 40 }} />
              </Link>
              <Link 
                href="https://www.facebook.com/up_stage_officiel"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                sx={{ 
                  '&:hover': { 
                    color: 'primary.dark',
                    transform: 'scale(1.1)'
                  },
                  transition: 'transform 0.2s'
                }}
              >
                <FacebookIcon sx={{ fontSize: 40 }} />
              </Link>
            </Stack>
          </Box>
        </Box>

        <Typography 
          variant="body2" 
          align="center" 
          sx={{ 
            mt: 4,
            pt: 2,
            borderTop: '1px solid rgba(0,0,0,0.2)'
          }}
        >
          © {new Date().getFullYear()} Up-Stage. Tous droits réservés.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer; 